// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { localCurrencySettings } from '../../../../utils/constans';

const AvailableToApproveWorkOrder = ({ fundsInfo }) => (
  <div className="form_section">
    <div className="field_column with_spacing">
      <div className="field_name">
        <label>Wallet Payment</label>
      </div>
      <div className="field_value">
        {fundsInfo.fundsNeededFromWallet.toLocaleString('en-US', localCurrencySettings)}
        {' '}
        Will Pay From Wallet
      </div>
    </div>

    <div className="field_column with_spacing">
      <div className="field_name">
        <label>Outside Payment</label>
      </div>
      <div className="field_value">
        {(fundsInfo.fundsNeeded - fundsInfo.fundsNeededFromWallet).toLocaleString(
          'en-US',
          localCurrencySettings,
        )}
        {' '}
        Will Pay Outside Of App
      </div>
    </div>
  </div>
);

export default AvailableToApproveWorkOrder;
